import { CalendarDays, Pencil } from 'lucide-react';
import {
  FieldLabel,
  campInputClass,
} from '@/features/campaigns/components/FormPrimitives';
import { formatCount } from '@/shared/lib/format/money';
import { MetricCard } from '../AiPreviewPrimitives';

type CampaignDetailsSectionProps = {
  campaignName: string;
  onCampaignNameChange: (value: string) => void;
  dateRange: string;
  totalRepetitions?: number;
  durationSec: number | null;
  totalScreens: number;
};

export function CampaignDetailsSection({
  campaignName,
  onCampaignNameChange,
  dateRange,
  totalRepetitions,
  durationSec,
  totalScreens,
}: CampaignDetailsSectionProps) {
  return (
    <>
      <section className="camp-section text-left">
        <div className="mb-3 flex items-center gap-2">
          <Pencil className="h-4 w-4 text-[var(--dash-brand)]" />
          <h2 className="m-0 text-[15px] font-semibold text-[var(--dash-ink)]">
            Campaign name
          </h2>
        </div>
        <FieldLabel
          required
          hint="You can rename this before launch"
          htmlFor="ai-campaign-name"
        >
          Name
        </FieldLabel>
        <input
          id="ai-campaign-name"
          type="text"
          maxLength={50}
          value={campaignName}
          onChange={(e) => onCampaignNameChange(e.target.value)}
          placeholder="e.g. Weekend Sale — Bhopal"
          className={`${campInputClass} mt-1.5`}
        />
        <div className="mt-1 flex items-center justify-start">
          <span className="text-[11px] text-[var(--dash-muted)]">
            {campaignName.length}/50
          </span>
        </div>
      </section>

      <section className="camp-section text-left">
        <div className="mb-4 flex items-center gap-2">
          <CalendarDays className="h-4 w-4 text-[var(--dash-brand)]" />
          <h2 className="m-0 text-[15px] font-semibold text-[var(--dash-ink)]">
            Campaign dates
          </h2>
        </div>
        <div className="mb-3 rounded-xl bg-[var(--dash-soft)] px-3.5 py-3">
          <p className="m-0 text-[11px] font-semibold tracking-wide text-[var(--dash-muted)] uppercase">
            Date range
          </p>
          <p className="m-0 mt-1 text-sm font-semibold text-[var(--dash-ink)]">
            {dateRange}
          </p>
        </div>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
          <MetricCard
            label="Total repetitions"
            hint="Total time of plays"
            value={
              totalRepetitions != null ? formatCount(totalRepetitions) : '—'
            }
          />
          <MetricCard
            label="Duration"
            hint="How long each ad plays"
            value={durationSec != null ? `${durationSec}s` : '—'}
          />
          <MetricCard
            label="Total screens"
            value={String(totalScreens || '—')}
          />
        </div>
      </section>
    </>
  );
}
